import React from "react";

const AnswerModalIcon = () => {
  return (
    <svg
      height="24px"
      width="24px"
      viewBox="0 0 512 512"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
    >
      <path
        style={{ fill: "#7D5A50" }}
        d="M136.283,273.102c-62.237,0-76.384,67.797-76.96,142.49c-0.024,3.108,1.881,5.907,4.8,7.215
        c9.997,4.479,22.118,8.033,35.643,10.342l72.822,0.036c13.61-2.309,25.805-5.877,35.854-10.378c2.919-1.308,4.824-4.107,4.8-7.215
        C212.668,340.899,198.521,273.102,136.283,273.102z"
      />
      <path
        style={{ fill: "#D29B6E" }}
        d="M221.795,486.881v-10.766c0-9.206-4.933-17.706-12.926-22.274l-38.316-21.894
        c-5.328-3.045-8.617-8.711-8.617-14.849V401.37h-51.307v15.729c0,6.138-3.289,11.804-8.617,14.849l-38.313,21.894
        c-7.993,4.567-12.926,13.067-12.926,22.274v10.766c0,9.446,7.656,17.102,17.102,17.102h136.818
        C214.138,503.983,221.795,496.327,221.795,486.881z"
      />
      <path
        style={{ fill: "#F0C087" }}
        d="M179.039,341.511v45.333c0,9.011-4.728,17.361-12.455,21.998l-21.502,12.902
        c-5.416,3.249-12.182,3.249-17.598,0l-21.502-12.902c-7.727-4.636-12.455-12.987-12.455-21.998v-45.333c0,0,51.307,0,68.409-17.102
        L179.039,341.511z"
      />
      <g>
        <path
          style={{ fill: "#E4EAF6" }}
          d="M208.87,453.842l-24.963-14.264c-4.716,6.692-22.584,30.087-47.623,38.753
            c-25.039-8.666-42.908-32.061-47.623-38.753l-24.962,14.264c-7.993,4.567-12.926,13.068-12.926,22.274v10.766
            c0,9.446,7.656,17.102,17.102,17.102h136.818c9.446,0,17.102-7.656,17.102-17.102v-10.766
            C221.795,466.909,216.862,458.409,208.87,453.842z"
        />
        <path
          style={{ fill: "#E4EAF6" }}
          d="M264.551,50.772H59.323c-18.813,0-34.205,15.392-34.205,34.205v119.716
            c0,18.813,15.392,34.205,34.205,34.205h111.165v32.433c0,3.81,4.606,5.716,7.298,3.023l35.457-35.456h51.307
            c18.813,0,34.205-15.392,34.205-34.205V84.977C298.755,66.165,283.363,50.772,264.551,50.772z"
        />
      </g>
      <path
        style={{ fill: "#C3E678" }}
        d="M247.448,8.017h205.228c18.813,0,34.205,15.392,34.205,34.205v119.716
        c0,18.813-15.392,34.205-34.205,34.205H341.511v32.433c0,3.81-4.606,5.716-7.298,3.023l-35.457-35.456h-51.307
        c-18.813,0-34.205-15.392-34.205-34.205V42.221C213.244,23.409,228.636,8.017,247.448,8.017z"
      />
      <path
        style={{ fill: "#D29B6E" }}
        d="M461.683,437.883l-40.666-15.25c-6.675-2.503-11.097-10.394-11.097-17.522h-68.409
        c0,7.128-4.422,15.019-11.097,17.522l-40.666,15.25c-10.012,3.755-16.646,13.327-16.646,24.02v24.978
        c0,9.446,7.656,17.102,17.102,17.102h171.023c9.446,0,17.102-7.656,17.102-17.102v-24.978
        C478.329,451.21,471.696,441.638,461.683,437.883z"
      />
      <path
        style={{ fill: "#C3E678" }}
        d="M461.683,437.883l-32.892-12.334l-53.076,44.23l-53.076-44.23l-32.892,12.334
        c-10.012,3.755-16.646,13.327-16.646,24.02v24.978c0,9.446,7.656,17.102,17.102,17.102h171.023c9.446,0,17.102-7.656,17.102-17.102
        v-24.978C478.329,451.21,471.696,441.638,461.683,437.883z"
      />
      <path
        style={{ fill: "#F0C087" }}
        d="M433.142,301.031l-5.336,80.037c-0.497,7.46-4.224,14.331-10.205,18.817l-17.942,13.456
        c-4.44,3.331-9.841,5.131-15.392,5.131h-17.102c-5.551,0-10.952-1.8-15.392-5.131l-17.942-13.457
        c-5.98-4.485-9.708-11.357-10.205-18.817l-5.336-80.037c-1.316-19.742,14.342-36.48,34.129-36.48h46.594
        C418.798,264.551,434.458,281.289,433.142,301.031z"
      />
      <path
        style={{ fill: "#5A4146" }}
        d="M399.012,264.551h-46.594c-19.786,0-35.446,16.738-34.129,36.479l2.127,31.91
        c2.941-0.202,76.287-5.475,112.206-24.129l0.518-7.78C434.458,281.289,418.799,264.551,399.012,264.551z"
      />
      <path
        style={{ fill: "#D7DEED" }}
        d="M238.897,221.795h55.078c2.96-5.056,4.78-10.852,4.78-17.102v-8.551h-51.307
        c-18.813,0-34.205-15.392-34.205-34.205V50.772H187.59v119.716C187.59,198.779,210.607,221.795,238.897,221.795z"
      />
      <path
        d="M168.83,183.147c6.078-8.369,9.675-18.65,9.675-29.761v-25.653c0-27.995-22.777-50.772-50.772-50.772
        S76.96,99.737,76.96,127.733v25.653c0,27.995,22.777,50.772,50.772,50.772c11.111,0,21.392-3.597,29.761-9.675l7.326,7.326
        c1.565,1.565,3.617,2.348,5.668,2.348c2.051,0,4.104-0.782,5.668-2.348c3.131-3.131,3.131-8.206,0-11.337L168.83,183.147z
         M127.732,188.125c-19.155,0-34.739-15.583-34.739-34.739v-25.653c0-19.156,15.584-34.739,34.739-34.739
        s34.739,15.583,34.739,34.739v25.653c0,6.68-1.899,12.921-5.179,18.222l-2.513-2.513c-3.131-3.131-8.207-3.131-11.337,0
        c-3.131,3.131-3.131,8.206,0,11.337l2.513,2.513C140.653,186.226,134.412,188.125,127.732,188.125z"
      />
      <path
        d="M378.035,53.676c-2.646-11.464-12.71-19.471-24.476-19.471h-6.995c-11.764,0-21.829,8.006-24.476,19.471l-22.594,97.909
        c-0.995,4.314,1.694,8.618,6.009,9.614c4.314,0.995,8.618-1.693,9.615-6.008l6.458-27.991h56.97l6.459,27.991
        c0.856,3.708,4.155,6.216,7.804,6.216c0.598,0,1.204-0.067,1.81-0.207c4.314-0.995,7.004-5.3,6.009-9.614L378.035,53.676z
         M325.277,111.165l12.434-53.884c0.958-4.146,4.598-7.043,8.854-7.043h6.995c4.255,0,7.896,2.896,8.853,7.043l12.434,53.884H325.277
        z"
      />
      <path
        d="M452.676,0H247.448c-23.281,0-42.221,18.941-42.221,42.221v0.534H59.323c-23.281,0-42.221,18.941-42.221,42.221v119.716
        c0,23.281,18.941,42.221,42.221,42.221h103.148v22.473c-7.945-2.857-16.676-4.302-26.188-4.302c-31.94,0-55.141,16.171-68.96,48.065
        c-10.432,24.08-15.672,57.568-16.017,102.38c-0.048,6.247,3.696,11.975,9.539,14.591c5.305,2.377,11.06,4.472,17.217,6.278
        L59.72,446.881c-10.463,5.979-16.964,17.181-16.964,29.234v10.766c0,13.851,11.268,25.119,25.119,25.119h136.818
        c13.851,0,25.119-11.268,25.119-25.119v-10.766c0-12.053-6.501-23.255-16.965-29.234l-18.343-10.482
        c6.155-1.804,11.91-3.899,17.218-6.278c5.841-2.617,9.587-8.345,9.54-14.591c-0.345-44.811-5.585-78.3-16.017-102.38
        c-5.891-13.596-13.493-24.324-22.743-32.172l34.063-34.065h47.987c19.952,0,36.705-13.917,41.09-32.55l30.202,30.202
        c1.534,1.534,3.584,2.348,5.67,2.348c1.033,0,2.075-0.2,3.067-0.61c2.996-1.241,4.949-4.164,4.949-7.406v-34.739h103.148
        c23.28,0,42.221-18.941,42.221-42.221V42.221C494.897,18.941,475.956,0,452.676,0z M162.46,401.968l-21.502,12.902
        c-2.883,1.729-6.466,1.729-9.349,0l-21.502-12.902c-5.281-3.169-8.563-8.964-8.563-15.124v-37.557
        c5.317-0.264,12.787-0.818,20.909-1.977c16.975-2.425,29.989-6.522,38.836-12.211l9.733,9.733v42.013
        C171.022,393.004,167.742,398.799,162.46,401.968z M123.359,428.618c3.986,2.391,8.455,3.587,12.924,3.587s8.938-1.196,12.924-3.587
        l6.006-3.604c1.928,5.786,5.926,10.786,11.363,13.893l4.498,2.571c-4.001,5.367-17.024,21.366-34.79,28.327
        c-17.668-6.934-30.765-22.961-34.787-28.33l4.494-2.567c5.437-3.107,9.434-8.107,11.363-13.893L123.359,428.618z M213.778,476.115
        v10.766c0,5.01-4.076,9.086-9.086,9.086H67.874c-5.01,0-9.086-4.076-9.086-9.086v-10.766c0-6.313,3.405-12.181,8.887-15.313
        l19.811-11.32c3.49,4.939,20.836,27.978,46.263,36.454c0.823,0.275,1.679,0.412,2.535,0.412s1.712-0.137,2.535-0.412
        c25.427-8.475,42.773-31.515,46.263-36.454l19.811,11.321C210.373,463.934,213.778,469.801,213.778,476.115z M190.531,319.524
        c9.546,22.034,14.353,53.418,14.695,95.935c-0.017,0.01-0.036,0.02-0.06,0.031c-8.752,3.921-19.432,7.094-30.999,9.254
        c-2.603-1.66-4.214-4.542-4.214-7.647v-0.928l0.756-0.453c10.083-6.05,16.347-17.113,16.347-28.872v-45.334
        c0-2.126-0.844-4.164-2.348-5.668l-17.102-17.102c-3.131-3.131-8.207-3.131-11.337,0c-5.652,5.652-18.4,10.152-35.895,12.67
        c-14.253,2.051-26.724,2.084-26.846,2.084c-4.427,0-8.017,3.589-8.017,8.017v45.333c0,11.759,6.264,22.823,16.347,28.872
        l0.756,0.453v0.929c0,3.106-1.612,5.989-4.216,7.648c-11.559-2.158-22.25-5.337-30.997-9.256c-0.024-0.011-0.044-0.021-0.06-0.031
        c0.341-42.518,5.149-73.901,14.695-95.935c11.197-25.843,28.941-38.405,54.247-38.405S179.334,293.682,190.531,319.524z
         M264.551,230.881h-51.307c-2.126,0-4.165,0.844-5.668,2.348L178.505,262.3v-23.402c0-4.427-3.589-8.017-8.017-8.017H59.323
        c-14.44,0-26.188-11.748-26.188-26.188V84.977c0-14.44,11.748-26.188,26.188-26.188h145.904v103.148
        c0,23.281,18.941,42.221,42.221,42.221h43.29v0.534C290.738,219.133,278.99,230.881,264.551,230.881z M478.864,161.937
        c0,14.44-11.748,26.188-26.188,26.188H341.511c-4.427,0-8.017,3.589-8.017,8.017v23.402l-29.071-29.071
        c-1.503-1.504-3.542-2.348-5.668-2.348h-51.307c-14.44,0-26.188-11.748-26.188-26.188V42.221c0-14.44,11.748-26.188,26.188-26.188
        h205.228c14.44,0,26.188,11.748,26.188,26.188V161.937z"
      />
      <path
        d="M464.498,430.377l-40.666-15.25c-2.65-0.994-4.644-3.171-5.474-5.79l4.053-3.04c7.858-5.894,12.74-14.895,13.393-24.696
        l1.915-28.724c0-0.002,0-0.004,0-0.006c0-0.001,0-0.002,0-0.003l3.42-51.303c0.775-11.616-3.342-23.153-11.295-31.653
        c-7.954-8.501-19.191-13.377-30.833-13.377h-46.594c-11.641,0-22.88,4.876-30.832,13.377c-7.953,8.501-12.07,20.037-11.295,31.653
        l5.336,80.037c0.653,9.802,5.536,18.803,13.393,24.696l4.053,3.04c-0.828,2.619-2.824,4.796-5.474,5.79l-40.666,15.25
        c-13.068,4.9-21.848,17.57-21.848,31.526v24.978c0,13.851,11.268,25.119,25.119,25.119h171.023
        c13.851,0,25.119-11.268,25.119-25.119v-24.978C486.346,447.947,477.566,435.277,464.498,430.377z M333.294,280.865
        c5.006-5.35,11.797-8.297,19.124-8.297h46.594c7.326,0,14.118,2.947,19.124,8.297c5.006,5.351,7.494,12.323,7.007,19.633l0,0
        l-0.079,1.182c-27.248,15.519-81.868,21.52-97.168,22.935l-1.608-24.117C325.801,293.188,328.289,286.215,333.294,280.865z
         M328.964,340.629c14.292-1.275,63.014-6.484,94.867-20.461l-2.11,31.644c-0.887,13.248-12.851,24.439-26.129,24.439h-19.877
        c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h19.877c8.494,0,16.544-2.698,23.299-7.268
        c-1.13,3.335-3.223,6.298-6.099,8.455l-17.944,13.457c-3.032,2.275-6.792,3.527-10.582,3.527h-17.102
        c-3.79,0-7.55-1.253-10.582-3.527L338.64,393.47c-4.116-3.087-6.673-7.802-7.015-12.937L328.964,340.629z M346.962,419.755
        c5.79,4.343,12.965,6.734,20.202,6.734h17.102c7.237,0,14.412-2.391,20.202-6.734l0.814-0.611c1.797,3.112,4.254,5.823,7.206,7.933
        l-36.774,24.516l-36.775-24.517c2.953-2.11,5.41-4.822,7.206-7.933L346.962,419.755z M281.118,486.881v-24.978
        c0-7.31,4.599-13.947,11.445-16.513l28.764-10.786l46.372,30.915v30.448h-77.495C285.194,495.967,281.118,491.891,281.118,486.881z
         M470.313,486.881c0,5.01-4.076,9.086-9.086,9.086h-77.495v-30.448l46.373-30.916l28.764,10.786
        c6.845,2.566,11.445,9.203,11.445,16.513v24.979H470.313z"
      />
    </svg>
  );
};

export default AnswerModalIcon;
